module.exports = __webpack_public_path__ + "img/CRC2_pDC.8e613bc4.png";